export const SERVICE_URL = {
  defaultService: '/api',
  dicomService: '/dicom',
  auditLogsService: '/audit-logs',
  assetsService: '/assets/dynamika-config.js',
  webSocket: '/notifications',
};

export const SCORING_FORMS_CONTENT_PATHS = {
  scoringFormESM: '/forms/js/:formCode/:formCode.js',
  scoringFormESMDEV: '/dev/forms/js/:formCode/:formCode.js',
};

export const QUERY_MANAGEMENT_API = {
  qcQueries: 'qc/queries',
  qcQueriesById: 'qc/queries/:queryId',
  siteQueries: 'site/queries',
  siteQueriesById: 'site/queries/:queryId',
  qcQueriesRecipients: 'qc/queries/recipients',
  pmQueries: 'pm/queries',
  pmQueriesById: 'pm/queries/:queryId',
  sponsorQueries: 'sponsor/queries',
  sponsorQueriesById: 'sponsor/queries/:queryId',
};

export const CLINICAL_TRIAL_INVENTORY_API = {
  clinicalTrialInventoryScoringForms:
    '/clinical-trials/:ctId/inventory/scoring-forms/:itemId',
  clinicalTrialInventoryFunctions:
    '/clinical-trials/:ctId/inventory/functions/:itemId',
  clinicalTrialInventoryReportTemplates:
    '/clinical-trials/:ctId/inventory/report-templates/:itemId',
  clinicalTrialInventoryTags: '/clinical-trials/:ctId/inventory/tags/:itemId',
  clinicalTrialInventoryReaders:
    '/clinical-trials/:ctId/inventory/readers/:itemId',
  clinicalTrialInventoryMeasurements:
    '/clinical-trials/:ctId/inventory/measurements/:itemId',
  clinicalTrialInventoryInstruments:
    '/clinical-trials/:ctId/inventory/instruments/:itemId',
  clinicalTrialInventoryDictionaries:
    '/clinical-trials/:ctId/inventory/dictionaries/:itemId',
};

export const API_URL = {
  ...CLINICAL_TRIAL_INVENTORY_API,
  ...QUERY_MANAGEMENT_API,
  clinicalTrial: '/clinical-trials',
  clinicalTrialId: '/clinical-trials/:id',
  clinicalTrialActivate: '/clinical-trials/:id/activate',
  clinicalTrialAffiliate: '/upload/affiliations',
  clinicalTrialContext: '/clinical-trials/context',
  clinicalTrialController: '/clinical-trials/',
  clinicalTrialInventory: '/clinical-trials/inventory',
  clinicalTrialUtilsInventory: '/utils/clinical-trials/:ctId/inventories',
  clinicalTrialInventoryScoringFormsList:
    '/clinical-trials/:id/inventory/scoring-forms',
  clinicalTrialInventoryInstrumentsForImagingSpecialist:
    '/clinical-trials/:id/inventory/instruments/imaging-specialist',
  teamMembers: '/clinical-trials/:id/team-members',
  teamMemberUserId: '/clinical-trials/:id/team-members/:userId',
  teamMembersAll: '/clinical-trials/:id/team-members/all',
  notificationCounts: '/pm/subscriptions/counts',
  pmNotifications: '/pm/notifications',
  pmSubscriptions: '/pm/subscriptions',
  pmSubscribe: '/pm/subscriptions/subscribe',
  pmUnsubscribe: '/pm/subscriptions/unsubscribe',
  pmSubscription: '/pm/subscriptions/:subscriptionId',
  pmRecipients: '/pm/subscriptions/recipients',
  pmRecipientsExport: '/pm/subscriptions/recipients/export',
  pmSubscriptionsBulk: '/pm/subscriptions/bulk',
  pmSubscriptionsBulkTemplate: '/pm/subscriptions/bulk/template',
  usersAffiliation: '/clinical-trials/:id/team-members/users',
  clinicalTrialQuestionnaires: '/clinical-trials/:id/inventory/questionnaires',
  clinicalTrialQuestionnairesBinding:
    '/clinical-trials/:id/questionnaire-binding',
  clinicalTrialQuestionnairesUnbinding:
    '/clinical-trials/:id/questionnaire-binding/:questionnaireId',
  profileAuth: '/profile/auth',
  subjectList: '/upload/patients/v2',
  subjectDetail: '/upload/patients/:subjectId',
  supportSubjectList: '/support/:ctId/patients',
  supportSubject: '/support/:ctId/patients/:patientId',
  supportRemoveUpload: '/support/:ctId/data-collect/uploads/:uploadId/remove',
  supportTaskReopen: '/support/:ctId/is-tasks/:taskId/reopen',
  subject: '/patients/v2',
  sponsors: '/sponsors',
  therapeutic: '/inventory/therapeutic-areas',
  phases: '/inventory/phases',
  diseases: '/inventory/diseases',
  locations: '/inventory/data-storage-locations',
  imagingLabels: '/inventory/imaging/labels',
  ctLabels: '/clinical-trial/:ctId/labels',
  ctLabelsLabel: '/clinical-trial/:ctId/labels/:labelId',
  uploadForm: '/questionnaires/default',
  uploadInventoryQuestionnaires: '/upload/inventory/questionnaires',
  inventoryQuestionnaires: '/inventory/questionnaires',
  uploadItems: '/upload-items',
  uploadItemsUrl: '/upload-items/:uploadId/url',
  externalUserPatients: '/external-user/patients',
  externalUserPatientDetails: '/external-user/patients/:patientId',
  externalUserPatientVisits: '/external-user/patients/:patientId/visits',
  externalUserPatientFiles: '/external-user/patients/:patientId/files',
  externalUserFileDownload: '/external-user/files/:fileId/download',
  externalUserReportList: '/external-user/patients/:patientId/uploaded-files',
  externalUserUploadReport:
    '/external-user/patients/:patientId/visits/:visitId/files/upload',
  externalUserUploadReportConfirm:
    '/external-user/patients/:patientId/visits/:visitId/files/confirm',
  externalUserReportsDownload: '/external-user/files/download',
  validationSpecialistPatients: '/validation-specialist/patients',
  validationSpecialistPatientDetails:
    '/validation-specialist/patients/:patientId',
  validationSpecialistPatientVisits:
    '/validation-specialist/patients/:patientId/visits',
  validationSpecialistVisitUploads:
    '/validation-specialist/visits/:visitId/uploads',
  validationSpecialistFileDownload:
    '/validation-specialist/files/:fileId/download',
  validationSpecialistQuestionnaires: '/validation-specialist/questionnaires',
  validationSpecialistUpdateQuestionnaire:
    '/validation-specialist/:uploadItemId/questionnaire',
  facilities: '/inventory/imaging/facilities',
  institutions: '/clinical-trials/:id/team-members/institutions',
  clinicalTrialsAffiliations: '/clinical-trials/affiliations/by-role',
  qcTasks: '/qc/tasks',
  qcTask: '/qc/tasks/:taskId',
  qcTaskUploads: '/qc/tasks/:taskId/uploads',
  qcTaskUpload: '/qc/tasks/:taskId/uploads/:uploadId',
  qcTaskUploadEdtf: '/qc/tasks/:taskId/uploads/:uploadId/edtf',
  qcUploadSendToWorkStation:
    '/qc/tasks/:taskId/uploads/:uploadId/send-to-workstation',
  qcTaskAssignToMe: '/qc/tasks/:taskId/assign-to-me',
  qcTaskComments: '/qc/tasks/:taskId/comments',
  qcTaskDefinition: '/qc/task-definitions',
  qcTaskDefinitionsUpdate: '/qc/task-definitions/:taskDefinitionId',
  qcTaskDefinitionsStatus: '/qc/task-definitions/:taskDefinitionId/status',
  DXAWorkstationData: '/qc/tasks/:taskId/dxa-workstation-data',
  DXAVisitData: '/qc/tasks/:taskId/dxa-visit-data',
  DXASync: '/qc/tasks/:taskId/executions/query-workstation',
  QCTWorkstationData: '/qc/tasks/:taskId/qct-workstation-data',
  QCTVisitData: '/qc/tasks/:taskId/qct-visit-data',
  QCTQuery: '/qc/tasks/:taskId/executions/qct/query',
  QCTExport: '/qc/tasks/:taskId/executions/qct/export',
  qcTaskExecutions: '/qc/tasks/:taskId/executions',
  qcTaskExecutionsExportRun: '/qc/tasks/:taskId/executions/export/run',
  qcTaskExecutionsExportResult:
    '/qc/tasks/:taskId/executions/export/:taskExecutionInstanceId/result',
  qcTaskExecutionsImportInit: '/qc/tasks/:taskId/executions/import/init',
  qcTaskExecutionsImportRun: '/qc/tasks/:taskId/executions/import/run',
  qcTaskSeries: '/qc/tasks/:taskId/series',
  DICOMResource: '/qc/tasks/series/location',
  qcTaskPatient: '/qc/tasks/:taskId/patient',
  qcPatientStatus: '/qc/tasks/:taskId/patient/upload-status',
  qcUpdatePatientDob: '/qc/patients/:id/dob',
  qcUpdatePatientSite: '/qc/patients/:id/site',
  qcUpdatePatientCode: '/qc/patients/:id/code',
  qcPatientVisitsDates: '/qc/patients/:id/visits/dates',
  qcTaskStatus: '/qc/tasks/:taskId/status',
  userManagement: '/usermanagement/users',
  userManagementDeactivate: '/usermanagement/users/:id/deactivate',
  userManagementReactivate: '/usermanagement/users/:id/reactivate',
  userManagementResendInvitation: '/usermanagement/users/:id/resend-invitation',
  userManagementInstitution: '/organizations/user-associated',
  invitations: '/usermanagement/invitations',
  invitationById: '/usermanagement/invitations/:id',
  invitationSponsors: '/usermanagement/invitations/sponsors',
  organizations: '/organizations',
  auditTrialLegacy: '/dashboard/audit/patients',
  auditTrial: '/dashboard/audit/clinical-trials',
  auditBusinessProcesses: '/dashboard/audit/business-processes',
  organizationsAll: '/organizations/all',
  readerTasks: '/reader/tasks',
  readerTasksAll: '/reader/tasks/all',
  readerTask: '/reader/tasks/:taskId',
  readerParentTask: '/reader/tasks/:parentTaskId/:taskId',
  viewerTask: '/viewer/tasks/:taskId',
  viewerParentTask: '/viewer/tasks/:parentTaskId/:taskId',
  /**
   * Every study of a grouped reading, in one request
   *
   * Plain terms
   * -----------
   * A reading that spans several visits is one parent task owning one task per
   * visit. This asks the parent "what images does this reading have?" and gets
   * every visit's study back, including the ones the reader is not scoring yet.
   *
   * Technical
   * ---------
   * Deliberately the ONE-segment form, filled with the PARENT task id. The
   * backend also exposes `/{parentTaskId}/{taskId}/dicom/series`, but that one
   * answers for a single child and is therefore not registered here (D7-7712).
   */
  readerReadingDicomSeries: '/reader/tasks/:taskId/dicom/series',
  viewerReadingDicomSeries: '/viewer/tasks/:taskId/dicom/series',
  readerDICOMResource: '/reader/tasks/series/location',
  viewerDICOMResource: '/viewer/tasks/series/location',
  commonDICOMResource: '/dicom/location',
  readerTaskDICOMDownloadAudit: '/reader/tasks/:taskId/log/dicom-download',
  readerTaskSubtaskDICOMDownloadAudit:
    '/reader/tasks/:taskId/:subTaskId/log/dicom-download',
  readerTaskStatus: '/reader/tasks/:taskId/status',
  readerTaskScoring: '/reader/tasks/:taskId/scoring',
  readerParentTaskScoring: '/reader/tasks/:parentTaskId/:taskId/scoring',
  readerTaskStart: '/reader/tasks/:taskId/start',
  readerParentTaskStart: '/reader/tasks/:parentTaskId/:taskId/start',
  readerTaskComplete: '/reader/tasks/:taskId/complete',
  readerParentTaskComplete: '/reader/tasks/:parentTaskId/:taskId/complete',
  readerTaskCalculate: '/reader/tasks/:taskId/calculate',
  readerParentTaskCalculateRano:
    '/reader/tasks/:parentTaskId/:taskId/calculate/rano',
  readerParentTaskCalculateRecist:
    '/reader/tasks/:parentTaskId/:taskId/calculate/recist/1.1',
  readerParentTaskCalculateFirstVisitScoring:
    '/reader/tasks/:parentTaskId/:taskId/calculate/first/scoring',
  readerParentTaskCalculatePreviousVisitScoring:
    '/reader/tasks/:parentTaskId/:taskId/calculate/previous/scoring',
  readerTaskMeasurements: '/reader/tasks/:taskId/measurements',
  readerTaskMeasurement: '/reader/tasks/:taskId/measurements/:measurementId',
  readerTaskMeasurementLock:
    '/reader/tasks/:taskId/measurements/:measurementId/lock',
  readerTaskMeasurementUnlock:
    '/reader/tasks/:taskId/measurements/:measurementId/unlock',
  readerTaskMeasurementGetScreenshot:
    '/reader/tasks/:taskId/measurements/:measurementId/screenshot',
  readerTaskMeasurementScreenshot:
    '/reader/tasks/:taskId/measurements/:measurementId/screenshot/confirm',
  reports: '/reports',
  reportsUrl: '/reports/:reportId/url',
  reportsStatus: '/reports/:reportId/status',
  pmTaskDefinition: '/pm/task-definitions',
  pmTaskDefinitionUpdate: '/pm/task-definitions/:taskDefinitionId',
  wsNotificationsReader: '/notifications/reader',
  utilsWorkflows: '/utils/workflows',
  dashboardPage: '/dashboard/data/:type/page',
  dashboardSummary: '/dashboard/data/:type/summary',
  dashboardEligibility: '/dashboard/data/:type/list',
  qcPatientVisitLock: '/qc/patients/:id/visits/:visitId/lock',
  qcPatientVisitUnlock: '/qc/patients/:id/visits/:visitId/unlock',
  qcPatientVisitMove: '/qc/patients/:id/visits/:visitId/move',
  viewerTasks: '/viewer/tasks',
  viewerTaskDicomToken: '/viewer/tasks/:taskId/dicom/token',
  viewerTasksAll: '/viewer/tasks/all',
  viewerIsTasks: '/viewer/is-tasks',
  viewerIsTasksContext: '/viewer/is-tasks/:taskId/dicom/context',
} as const;
